import React from 'react';

export const AppLayout = React.lazy(() => import('./App/AppLayout'));
export const LoginLayout = React.lazy(() => import('./login/LoginLayout'));
export const SettingsLayout = React.lazy(() => import('./settings/SettingsLayout'));
export const ReportsLayout = React.lazy(() => import('./reports/ReportsLayout'));
